import { Injectable } from '@angular/core';
import { TuiAlertService } from '@taiga-ui/core';
import { take } from 'rxjs';

const ERROR_HEADING = 'Ошибка';
const WARNING_HEADING = 'Внимание';
const INFO_HEADING = 'Информация';
const SUCCESS_HEADING = 'Успешно';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(private readonly alertService: TuiAlertService) {}

  showError(message = '') {
    this.alertService
      .open(typeof message === 'object' ? 'Ошибка сервера' : message, {
        label: ERROR_HEADING,
        appearance: 'error',
        autoClose: 3_000,
      })
      .pipe(take(1))
      .subscribe();
  }

  showSuccess(message = '') {
    this.alertService
      .open(message, {
        label: SUCCESS_HEADING,
        appearance: 'success',
        autoClose: 3_000,
      })
      .pipe(take(1))
      .subscribe();
  }

  showWarning(message = '') {
    this.alertService
      .open(message, {
        label: WARNING_HEADING,
        appearance: 'warning',
        autoClose: 3_000,
      })
      .pipe(take(1))
      .subscribe();
  }

  showInfo(message = '') {
    this.alertService
      .open(message, {
        label: INFO_HEADING,
        appearance: 'info',
        autoClose: 3_000,
      })
      .pipe(take(1))
      .subscribe();
  }
}
